module.exports = __webpack_public_path__ + "img/파라솔 (2).f558c439.jpg";